/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getToolState, removeToolState } from 'cornerstone-tools';

import OnClickToolButton from 'app/components/ToolsBar/OnClickToolButton';
import ToolWithOptions from 'app/components/ToolsBar/ToolWithOptions';
import { OPTIONS_WITH_SELECTED } from 'app/components/ToolsBar/utils';

type RealSizeMeasurementConfigurationButtonProps = {
  isRealSizeMeasurementConfigurationOngoing: boolean;
  toggleRealSizeMeasurementConfiguration: (shouldToggle: boolean) => void;
  currentCalibrationKey?: string;
  calibrationOptions?: {
    title: string | React.ReactNode;
    callback: () => void;
    isSelected?: boolean;
  }[];
} & (
  | {
      focusedElement: HTMLElement; // Cornerstone style usage
    }
  | {
      resetRealSizeMeasurement?: () => void; // Dependency injection style
    }
);

export default function RealSizeMeasurementConfigurationButton({
  isRealSizeMeasurementConfigurationOngoing,
  toggleRealSizeMeasurementConfiguration,
  ...props
}: RealSizeMeasurementConfigurationButtonProps) {
  let resetAction = () => {};

  if ('resetRealSizeMeasurement' in props) {
    resetAction = props.resetRealSizeMeasurement;
  } else if ('focusedElement' in props) {
    resetAction = () => {
      const toolData = getToolState(props.focusedElement, this.name);
      const measurement = toolData?.data?.[0];
      if (measurement) {
        removeToolState(props.focusedElement, 'RealSizeMeasurementCalibration', measurement);
      }
    };
  }
  const actions =
    props.calibrationOptions && props.calibrationOptions.length > 0
      ? props.calibrationOptions?.map(({ title, callback, isSelected }) => ({
          content: title,
          action: callback,
          isSelected,
        }))
      : [
          {
            content: <FormattedMessage id="general.reset" />,
            action: resetAction,
          },
        ];

  return (
    <>
      <ToolWithOptions
        content={
          <OnClickToolButton
            aria-label="realsize-measurement-button"
            onClick={() => toggleRealSizeMeasurementConfiguration(true)}
            content={<i className="svg-icon ruler" />}
            tooltipId="tools.real_size.tooltip"
            isActive={isRealSizeMeasurementConfigurationOngoing}
          />
        }
        actions={actions}
        aria-label="realsize-measurement-options"
        isOptionSelected={({ isSelected, ...rest }: { isSelected?: boolean }) => isSelected}
        styles={OPTIONS_WITH_SELECTED}
      />
    </>
  );
}
